import { useRouter } from "next/router";

const useHandleWebView = () => {
  const router = useRouter();
  const { query } = router;
  const isWebView = query.webview === "1";
  const isDarkMode = query.darkmode === "1";
  return { isWebView, isDarkMode };
};

export default useHandleWebView;
